import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { fetchConfigurationsDropdown } from "pages/AdminManage/actions";
import { isArray, isEmpty, map, find, isEqual } from "lodash";
import { CustomDropdownContainer } from "CommonComponent";

const CONFIG_TYPE = "business";

const BussinesModelDropdown = ({
  selectedId = "",
  selectedChangingId = "",
  value,
  setValue,
  onChange,
  setAllIds,
  showSelectAllOption = true,
  isMulti = true,
  placeholder = "Select",
  label = "Business Model",
  name = "business_model_id",
  error = "",
  queue_id = null,
}) => {
  const dispatch = useDispatch();
  const session = useSelector((s) => s.session);
  const dropdownList = useSelector(
    (state) => state.configurationState.dropdowns[CONFIG_TYPE],
  );
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const object_viewed_id = session?.current_page_permissions?.object_id;

   
    if (!object_viewed_id) {
      return;
    }

    const params = { object_viewed_id };
    if (queue_id) {
      params.queue_id = queue_id;
    }

    dispatch(fetchConfigurationsDropdown(CONFIG_TYPE, params));
  }, [dispatch, queue_id, session.current_page_permissions]);

  useEffect(() => {
    if (!selectedChangingId || !dropdownList) return;

    if (isArray(selectedChangingId)) {
      const selected = selectedChangingId
        .map((id) => find(dropdownList, ["id", id]))
        .filter(Boolean)
        .map((item) => ({ value: item.id, label: item.name }));
      setValue(selected);
    } else {
      const selected = find(dropdownList, ["id", selectedChangingId]);
      setValue(selected ? { value: selected.id, label: selected.name } : null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChangingId, dropdownList]);

  useEffect(() => {
    if (!dropdownList) return;

    const formattedOptions = map(dropdownList, (item) => ({
      value: item.id,
      label: item.name,
    }));

    if (showSelectAllOption && isMulti) {
      formattedOptions.unshift({ value: "all", label: "All" });
    }

    setOptions(formattedOptions);

    if (typeof setAllIds === "function") {
      setAllIds(map(dropdownList, "id"));
    }

    if (!isEmpty(selectedId)) {
      if (isArray(selectedId)) {
        const selected = selectedId
          .map((id) => find(formattedOptions, ["value", id]))
          .filter(Boolean);

        if (!isEqual(value, selected)) {
          setValue(selected);
        }
      } else {
        const selected = find(formattedOptions, ["value", selectedId]);
        if (!isEqual(value, selected)) {
          setValue(selected || null);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownList, selectedId, isMulti, showSelectAllOption]);

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label className="label-input">{label}</Form.Label>
        <Select
          name={name}
          options={options}
          value={value}
          onChange={onChange}
          isMulti={isMulti}
          placeholder={placeholder}
          className="multi-select w-100"
          classNamePrefix="react-select"
          isSearchable
          components={{ ValueContainer: CustomDropdownContainer }}
        />
        {error && <div className="invalid-feedback d-block">{error}</div>}
      </Form.Group>
    </>
  );
};

BussinesModelDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  value: PropTypes.any,
  selectedId: PropTypes.any,
  selectedChangingId: PropTypes.any,
  setAllIds: PropTypes.func,
  isMulti: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.string,
  queue_id: PropTypes.any,
};

export default BussinesModelDropdown;
